/**
 * Welcome — стартовый экран онбординга. Первый шаг Flow (step="welcome"), по «Начать» → phone.
 * Пропсы: onNext() — перейти к следующему шагу.
 * Кнопка: в мессенджере — нативная MainButton, в вебе — FallbackButton.
 */
import { useMainButton } from "@/telegram/useMainButton";
import { Screen, FallbackButton } from "@/components/Screen";
import { Hero } from "@/components/Hero";
import { IconTile } from "@/components/IconTile";

export function Welcome({ onNext }: { onNext: () => void }) {
  useMainButton({ text: "Начать", onClick: onNext });
  return (
    <Screen footer={<FallbackButton text="Начать" onClick={onNext} />}>
      <Hero
        size="lg"
        icon={<span className="text-5xl font-bold">$</span>}
        title="Купить USD за рубли"
        subtitle="Быстро и безопасно. Пополняйте рублёвый счёт по реквизитам после подтверждения оплаты."
      />

      <div className="mt-9 space-y-2.5">
        <Step icon="📞" tint="from-emerald-400/25 to-emerald-500/10" title="Подтвердите номер" desc="Звонок-сброс — бесплатно, без SMS" />
        <Step icon="🪪" tint="from-sky-400/25 to-sky-500/10" title="Загрузите паспорт" desc="Нужен один раз для верификации" />
        <Step icon="💳" tint="from-teal-400/25 to-teal-500/10" title="Получите счёт" desc="Рублёвый счёт — открывается сразу" />
        <Step icon="💰" tint="from-violet-400/25 to-violet-500/10" title="Пополните счёт" desc="По указанным реквизитам" />
      </div>
    </Screen>
  );
}

function Step({ icon, tint, title, desc }: { icon: string; tint: string; title: string; desc: string }) {
  return (
    <div className="flex items-center gap-3.5 rounded-2xl border border-white/[0.06] bg-surface-card px-4 py-3.5">
      <IconTile icon={icon} tint={tint} className="h-11 w-11 text-[20px]" />
      <div className="min-w-0">
        <div className="text-[15px] font-medium">{title}</div>
        <div className="mt-0.5 text-[13px] text-white/45">{desc}</div>
      </div>
    </div>
  );
}
